/* Ładowany przez snippets/product-information-blocks.liquid i sections/collapsible-tabs.liquid.
   Akordeon (details[is="accordion-group"], theme.js) po otwarciu jednej zakładki automatycznie
   zamyka pozostałe. Gdy zamykana zakładka miała długą, rozwiniętą treść, strona nad kliknięciem
   gwałtownie się kurczy i przesuwa widok w górę — użytkownik traci z oczu właśnie otwartą zakładkę.
   Ten skrypt przez cały czas trwania animacji accordiona (klatka po klatce) kompensuje przesunięcie
   strony, tak żeby kliknięty nagłówek pozostał wizualnie w tym samym miejscu ekranu. */
(function () {
  var LOCK_DURATION = 500; // ms — dłużej niż animacja accordiona w theme.js (~250-400ms)
  var activeToken = 0;

  function lockViewportTo(el, duration) {
    var token = ++activeToken;
    var start = performance.now();
    var lastTop = el.getBoundingClientRect().top;

    function step(now) {
      if (token !== activeToken) return;

      var currentTop = el.getBoundingClientRect().top;
      var delta = currentTop - lastTop;
      if (delta !== 0) {
        window.scrollBy(0, delta);
      }
      lastTop = el.getBoundingClientRect().top;

      if (now - start < duration) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('.accordion-details__summary');
    if (!summary) return;
    if (!summary.closest('.accordion-parent')) return;
    if (!summary.closest('details[is="accordion-group"]')) return;

    lockViewportTo(summary, LOCK_DURATION);
  });
})();
